import { computed, provide } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-792c4ff2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "menu_box"
};
import { useStore } from 'vuex';
export default {
  __name: 'LeftMenu',
  props: {
    collapsed: Boolean
  },
  setup(__props) {
    const props = __props;
    const store = useStore();
    const menuArr = computed(() => store.state.menuList);
    const openKeys = computed(() => {
      if (store.state.openKeys.length > 0) {
        return store.state.openKeys;
      } else {
        if (menuArr.value.length > 0) {
          return [menuArr.value[0].id];
        }
      }
    });
    const selectedKeys = computed(() => store.state.curSelKey ? [store.state.curSelKey] : []);
    const menuClick = e => {
      if (e.meta.type == 'MENU') {
        if (e.component == '') {
          e.component = 'share/DMList';
        }
        store.commit('addTab', e);
      }
    };
    provide('menuClick', menuClick);
    const handleClick = e => {
      store.commit('setopenKeys', e.keyPath[0]);
    };
    return (_ctx, _cache) => {
      const _component_LeftMenuItem = _resolveComponent("LeftMenuItem");
      const _component_a_menu = _resolveComponent("a-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_menu, {
        theme: "dark",
        mode: "inline",
        openKeys: _unref(openKeys),
        "onUpdate:openKeys": _cache[0] || (_cache[0] = $event => _isRef(openKeys) ? openKeys.value = $event : null),
        selectedKeys: _unref(selectedKeys),
        "onUpdate:selectedKeys": _cache[1] || (_cache[1] = $event => _isRef(selectedKeys) ? selectedKeys.value = $event : null),
        inlineCollapsed: __props.collapsed,
        onClick: handleClick
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuArr), (item, idnex) => {
          return _openBlock(), _createBlock(_component_LeftMenuItem, {
            key: idnex,
            menuInfo: item,
            collapsed: __props.collapsed
          }, null, 8, ["menuInfo", "collapsed"]);
        }), 128))]),
        _: 1
      }, 8, ["openKeys", "selectedKeys", "inlineCollapsed"])]);
    };
  }
};